"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = require("styled-components");

var _default = function _default(fn) {
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return (0, _styledComponents.css)(["", ""], function (_ref) {
      var theme = _ref.theme;
      return fn.apply(void 0, [theme].concat(args));
    });
  };
};

exports["default"] = _default;
//# sourceMappingURL=createMixin.js.map